export const HANDLE_CHANGE_SOCIAL_PAY_INPUT = 'HANDLE_CHANGE_SOCIAL_PAY_INPUT';
export function handleChangeSocialPayInput (provider, changedProps) {
  return {
    type: HANDLE_CHANGE_SOCIAL_PAY_INPUT,
    payload: {
      provider,
      changedProps,
    },
  };
}

import LGTM from 'lgtm';
import Providers from '../constants/SocialPayConstants';
const tweetValidator =
  LGTM.validator()
    .validates('message')
      .required('Enter Tweet Message')
      .using(message => message.length <= 100, 'Tweet message should be less than 100 characters')
    .build();

const validatorMap = {
  [Providers.TWITTER]: tweetValidator,
};


export const HANDLE_SOCIAL_PAY_SUCCESS = 'HANDLE_SOCIAL_PAY_SUCCESS';
function handleSocialPaySuccess () {
  return {
    type: HANDLE_SOCIAL_PAY_SUCCESS,
  };
}

export const HANDLE_SOCIAL_PAY_FAILURE = 'HANDLE_SOCIAL_PAY_FAILURE';
function handleSocialPayFailure (errors) {
  return {
    type: HANDLE_SOCIAL_PAY_FAILURE,
    errors,
  };
}

export function handleSubmitSocialPayForm () {
  return (dispatch, getState) => {
    const { selectedSocialPayPlatform } = getState().finalizeSocialPay;
    const selectedSocialPayPlatformData = getState().finalizeSocialPay[selectedSocialPayPlatform];
    const validator = validatorMap[selectedSocialPayPlatform];
    validator.validate(selectedSocialPayPlatformData, (e, result) => {
      if (!result.valid) {
        return dispatch(handleSocialPayFailure(result.errors));
      }
      dispatch(handleSocialPaySuccess());
    });
  };
}



// WEBPACK FOOTER //
// ./src/payments/actions/FinalizeSocialPayActions.js